export const transactionPaymentTypes = {
  scanner: 'SCANNER',
  cash: 'CASH',
  creditCard: 'CARD',
}

export const paymentMethodDeleteMessage =
  'Cannot delete payment method because the payment is mapped to an wine-club membership'
